import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-lightgray" data-testid="auth-loading">
        <div className="w-10 h-10 border-2 border-navy border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
